module.exports = __webpack_public_path__ + "static/media/header-search-icon.f8983cbb.svg";